var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-row',{attrs:{"justify":"space-between"}},[_c('v-col',{attrs:{"cols":"auto"}},[_c('h3',{staticClass:"card-title align-items-start flex-column"},[_c('span',{staticClass:"card-label font-weight-bolder text-dark"},[_vm._v("Custom Environment")])])])],1),_c('div',[_c('custom-table',{ref:"ciTable"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }